export default __webpack_public_path__ + "static/media/CentralisedData_Image.6f6702d8.png";